/**
 * Formata uma data para exibição no formato brasileiro (versão para componentes)
 * @param dateString String de data no formato ISO ou timestamp
 * @returns Data formatada em pt-BR ou 'Não informado' se inválida
 */
export const formatDateForDisplay = (dateString?: string): string => {
  if (!dateString) return 'Não informado';
  return new Date(dateString).toLocaleDateString('pt-BR');
};

/**
 * Formata uma data para uso em inputs do tipo date (YYYY-MM-DD)
 * @param dateString String de data no formato ISO ou timestamp
 * @returns Data no formato YYYY-MM-DD ou string vazia se inválida
 */
export const formatDateForInput = (dateString?: string): string => {
  if (!dateString) return '';
  return dateString.split('T')[0];
};

/**
 * Formata uma data e hora para exibição completa
 * @param dateString String de data no formato ISO ou timestamp
 * @returns Data e hora formatadas em pt-BR ou 'Não informado' se inválida
 */
export const formatDateTimeForDisplay = (dateString?: string): string => {
  if (!dateString) return 'Não informado';
  return new Date(dateString).toLocaleString('pt-BR');
};

/**
 * Verifica se uma data está vencida
 * @param dateString String de data no formato ISO ou timestamp
 * @returns true se a data já passou, false caso contrário
 */
export const isDateExpired = (dateString?: string): boolean => {
  if (!dateString) return false;
  return new Date(dateString) < new Date();
};

/**
 * Calcula a diferença em dias entre duas datas
 * @param startDate Data inicial
 * @param endDate Data final
 * @returns Número de dias de diferença
 */
export const getDaysDifference = (startDate: string, endDate: string): number => {
  const start = new Date(startDate);
  const end = new Date(endDate);
  const diffTime = Math.abs(end.getTime() - start.getTime());
  return Math.ceil(diffTime / (1000 * 60 * 60 * 24));
};